var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "basic-container",
    [
      _c("div", { staticClass: "query-form-wrap" }, [
        _c(
          "div",
          { staticClass: "query-form-wrap-left" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  inline: true,
                  model: _vm.searchForm,
                  size: _vm.formSize,
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "媒资名称" } },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "请输入媒资名称" },
                      model: {
                        value: _vm.searchForm.name,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "name", $$v)
                        },
                        expression: "searchForm.name",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "明星" } },
                  [
                    _c("el-input", {
                      attrs: { clearable: "", placeholder: "请输入明星姓名" },
                      model: {
                        value: _vm.searchForm.staffMemberName,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "staffMemberName", $$v)
                        },
                        expression: "searchForm.staffMemberName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { size: "small", label: "媒资类型" } },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "全部" },
                        model: {
                          value: _vm.searchForm.type,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "type", $$v)
                          },
                          expression: "searchForm.type",
                        },
                      },
                      _vm._l(_vm.type, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      size: "small",
                      label: "状态",
                      prop: "channelNameStr",
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "全部" },
                        model: {
                          value: _vm.searchForm.status,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "status", $$v)
                          },
                          expression: "searchForm.status",
                        },
                      },
                      _vm._l(_vm.status, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      size: "small",
                      label: "来源",
                      prop: "channelNameStr",
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "全部" },
                        model: {
                          value: _vm.searchForm.sourceType,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "sourceType", $$v)
                          },
                          expression: "searchForm.sourceType",
                        },
                      },
                      _vm._l(_vm.sourceType, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.label, value: item.value },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      size: "small",
                      label: "年份",
                      prop: "channelNameStr",
                    },
                  },
                  [
                    _c(
                      "el-select",
                      {
                        attrs: { clearable: "", placeholder: "全部" },
                        model: {
                          value: _vm.searchForm.year,
                          callback: function ($$v) {
                            _vm.$set(_vm.searchForm, "year", $$v)
                          },
                          expression: "searchForm.year",
                        },
                      },
                      _vm._l(_vm.year, function (item) {
                        return _c("el-option", {
                          key: item.value,
                          attrs: { label: item.dictValue, value: item.dictKey },
                        })
                      }),
                      1
                    ),
                  ],
                  1
                ),
                _c("el-form-item", [
                  _c(
                    "div",
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "auth",
                              rawName: "v-auth",
                              value: "MARKMANAGE_MEDIAMANAGE_SEARCH",
                              expression: "'MARKMANAGE_MEDIAMANAGE_SEARCH'",
                            },
                          ],
                          attrs: { icon: "el-icon-search", type: "primary" },
                          on: { click: _vm.handleSearch },
                        },
                        [_vm._v("搜索")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { icon: "el-icon-delete" },
                          on: { click: _vm.handleClear },
                        },
                        [_vm._v("清空")]
                      ),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "div",
        [
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "auth",
                  rawName: "v-auth",
                  value: "MARKMANAGE_MEDIAMANAGE_ADD",
                  expression: "'MARKMANAGE_MEDIAMANAGE_ADD'",
                },
              ],
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  _vm.addDialog = true
                },
              },
            },
            [_vm._v("新增")]
          ),
        ],
        1
      ),
      _c("br"),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: { height: "550", data: _vm.mediaData, border: "" },
          on: { "selection-change": _vm.handleSelectionChange },
        },
        [
          _c("el-table-column", {
            attrs: { type: "index", width: "50", label: "序号" },
          }),
          _c("el-table-column", {
            attrs: { width: "80", prop: "coverImage", label: "媒资图片" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _vm.isShowIframe
                          ? _c("ImageIframe", {
                              staticStyle: { width: "75px", height: "70px" },
                              attrs: { url: data.row.coverImage },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { width: "150", prop: "name", label: "媒资名称" },
          }),
          _c("el-table-column", {
            attrs: { width: "100", prop: "type", label: "媒资类型" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (data) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.valueToLabel(_vm.typeOptions, data.row.type)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", { attrs: { prop: "year", label: "年份" } }),
          _c("el-table-column", {
            attrs: { prop: "sourceType", label: "来源" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (data) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.valueToLabel(
                            _vm.payStatusOptions,
                            data.row.payType
                          ) +
                            _vm.valueToLabel(
                              _vm.sourcePlatformOptions,
                              data.row.sourceType
                            )
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "status", label: "状态" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (data) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.valueToLabel(_vm.statusOptions, data.row.status)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "primary", label: "是否主媒资" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (data) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.valueToLabel(_vm.primaryOptions, data.row.primary)
                        ) +
                        "\n      "
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { label: "媒资标签" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              placement: "top-start",
                              trigger: "hover",
                              content: data.row.tagName,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  "white-space": "nowrap",
                                  overflow: "hidden",
                                  "text-overflow": "ellipsis",
                                },
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              _vm._l(
                                data.row.tagName.split(","),
                                function (item) {
                                  return _c(
                                    "el-tag",
                                    {
                                      key: item.id,
                                      staticStyle: { "margin-right": "10px" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(item) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                }
                              ),
                              1
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "updateTime", label: "最后更新时间", width: "180" },
          }),
          _c("el-table-column", {
            attrs: { label: "操作" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "MARKMANAGE_MEDIAMANAGE_EDIT",
                            expression: "'MARKMANAGE_MEDIAMANAGE_EDIT'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleEdit(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "MARKMANAGE_MEDIAMANAGE_VIEW",
                            expression: "'MARKMANAGE_MEDIAMANAGE_VIEW'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleView(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.status === 2,
                            expression: "scope.row.status === 2",
                          },
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "MARKMANAGE_MEDIAMANAGE_STATE",
                            expression: "'MARKMANAGE_MEDIAMANAGE_STATE'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleTakeOn(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("上架")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.status === 1,
                            expression: "scope.row.status === 1",
                          },
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "MARKMANAGE_MEDIAMANAGE_STATE",
                            expression: "'MARKMANAGE_MEDIAMANAGE_STATE'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleTakeOff(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("下架")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: scope.row.primary === true,
                            expression: "scope.row.primary === true",
                          },
                          {
                            name: "auth",
                            rawName: "v-auth",
                            value: "MARKMANAGE_MEDIAMANAGE_CONTACT",
                            expression: "'MARKMANAGE_MEDIAMANAGE_CONTACT'",
                          },
                        ],
                        attrs: { type: "text", size: "small" },
                        on: {
                          click: function ($event) {
                            return _vm.handleCorrelate(scope.row.id)
                          },
                        },
                      },
                      [_vm._v("关联")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _vm.editDialog
        ? _c(
            "el-dialog",
            {
              attrs: {
                title: _vm.disabled === false ? "编辑" : "查看",
                visible: _vm.editDialog,
                width: "60%",
                "before-close": _vm.handleClose,
                "modal-append-to-body": false,
              },
              on: {
                "update:visible": function ($event) {
                  _vm.editDialog = $event
                },
                closed: _vm.closeDialog,
              },
            },
            [
              _c(
                "el-form",
                {
                  ref: "editForm",
                  attrs: { model: _vm.editForm, rules: _vm.editRules },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "mediaAsset.name",
                        label: "媒资名称:",
                        "label-width": "20%",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          "show-word-limit": "",
                          disabled: _vm.disabled,
                          maxlength: "50",
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 8 },
                          placeholder: "请输入媒资名称",
                        },
                        model: {
                          value: _vm.editForm.mediaAsset.name,
                          callback: function ($$v) {
                            _vm.$set(_vm.editForm.mediaAsset, "name", $$v)
                          },
                          expression: "editForm.mediaAsset.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "mediaAsset.aliasName",
                        label: "媒资别名:",
                        "label-width": "20%",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          "show-word-limit": "",
                          disabled: _vm.disabled,
                          maxlength: "50",
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 8 },
                          placeholder: _vm.editForm.mediaAsset.aliasName
                            ? _vm.editForm.mediaAsset.aliasName
                            : "暂无媒资别名",
                        },
                        model: {
                          value: _vm.editForm.mediaAsset.aliasName,
                          callback: function ($$v) {
                            _vm.$set(_vm.editForm.mediaAsset, "aliasName", $$v)
                          },
                          expression: "editForm.mediaAsset.aliasName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "mediaAsset.type",
                        label: "媒资类型:",
                        "label-width": "20%",
                      },
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.editForm.mediaAsset.type))])]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "drama.episodes",
                        label: "集数:",
                        "label-width": "20%",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.editForm.drama.episodes
                              ? _vm.editForm.drama.episodes
                              : "集数未知"
                          )
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "mediaAsset.description",
                        label: "简介:",
                        "label-width": "20%",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          "show-word-limit": "",
                          disabled: _vm.disabled,
                          maxlength: "500",
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 8 },
                          placeholder: "请输入简介",
                        },
                        model: {
                          value: _vm.editForm.mediaAsset.description,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.editForm.mediaAsset,
                              "description",
                              $$v
                            )
                          },
                          expression: "editForm.mediaAsset.description",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "mediaAsset",
                        label: "简介:",
                        "label-width": "20%",
                      },
                    },
                    [
                      _c("div", { staticClass: "showMediaImg" }, [
                        _c(
                          "div",
                          { staticClass: "showMediaImg-left" },
                          [
                            _c("span", [_vm._v("封面图: ")]),
                            _vm.editForm.mediaAsset.isShowCoverImage
                              ? _c("ImageIframe", {
                                  attrs: {
                                    url: _vm.editForm.mediaAsset.coverImage,
                                    option: "coverImage",
                                  },
                                })
                              : _vm._e(),
                            !_vm.editForm.mediaAsset.coverImage
                              ? _c("span", [_vm._v("暂无图片")])
                              : _vm._e(),
                            _c(
                              "el-upload",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.disabled,
                                    expression: "!disabled",
                                  },
                                ],
                                staticClass: "upload-demo",
                                attrs: {
                                  "before-upload": _vm.checkUpload,
                                  "http-request": _vm.upload,
                                  listType: "picture-img",
                                  action: "coverImage",
                                  "on-preview": _vm.handlePreview,
                                  "on-remove": _vm.handleRemove,
                                  "before-remove": _vm.beforeRemove,
                                  "on-exceed": _vm.handleExceed,
                                  "show-file-list": false,
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { size: "small", type: "primary" } },
                                  [_vm._v("重新上传")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "div",
                          { staticClass: "showMediaImg-right" },
                          [
                            _c("span", [_vm._v("高清横屏图: ")]),
                            _vm.editForm.mediaAsset.isShowHdImage
                              ? _c("ImageIframe", {
                                  attrs: {
                                    url: _vm.editForm.mediaAsset.hdImage,
                                    option: "hdImage",
                                  },
                                })
                              : _vm._e(),
                            _c("div", {
                              staticClass: "mediaImg iframeClass",
                              attrs: { id: _vm.editForm.mediaAsset.hdImage },
                            }),
                            !_vm.editForm.mediaAsset.hdImage
                              ? _c("span", [_vm._v("暂无图片")])
                              : _vm._e(),
                            _c(
                              "el-upload",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.disabled,
                                    expression: "!disabled",
                                  },
                                ],
                                staticClass: "upload-demo",
                                attrs: {
                                  "before-upload": _vm.checkUpload,
                                  "http-request": _vm.upload,
                                  listType: "picture-img",
                                  action: "hdImage",
                                  "on-preview": _vm.handlePreview,
                                  "on-remove": _vm.handleRemove,
                                  "before-remove": _vm.beforeRemove,
                                  data: _vm.editForm.mediaAsset.hdImage,
                                  "on-exceed": _vm.handleExceed,
                                  "show-file-list": false,
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  { attrs: { size: "small", type: "primary" } },
                                  [_vm._v("重新上传")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ]),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "mediaAsset.score",
                        label: "评分:",
                        "label-width": "20%",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.editForm.mediaAsset.score) +
                          "\n      "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "mediaAsset.url",
                        label: "页面访问地址:",
                        "label-width": "20%",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.editForm.mediaAsset.url) +
                          "\n      "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "mediaAsset.urlScheme",
                        label: "app跳转地址:",
                        "label-width": "20%",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.editForm.mediaAsset.urlScheme) +
                          "\n      "
                      ),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "mediaAsset.tagName",
                        label: "备注:",
                        "label-width": "20%",
                      },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          "show-word-limit": "",
                          disabled: _vm.disabled,
                          maxlength: "99",
                          type: "textarea",
                          autosize: { minRows: 2, maxRows: 8 },
                          placeholder: _vm.editForm.mediaAsset.tagName
                            ? _vm.editForm.mediaAsset.tagName
                            : "暂无备注",
                        },
                        model: {
                          value: _vm.editForm.mediaAsset.tagName,
                          callback: function ($$v) {
                            _vm.$set(_vm.editForm.mediaAsset, "tagName", $$v)
                          },
                          expression: "editForm.mediaAsset.tagName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "mediaAsset.sourceType",
                        label: "来源平台:",
                        "label-width": "20%",
                      },
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(_vm.editForm.mediaAsset.sourceType) +
                          "\n      "
                      ),
                    ]
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        "max-height": "31.25rem",
                        overflow: "auto",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "staffMembers",
                            label: "明星列表:",
                            "label-width": "20%",
                          },
                        },
                        [
                          _vm.editForm.staffMembers.length
                            ? _c(
                                "div",
                                { staticClass: "showMediaImg" },
                                _vm._l(
                                  _vm.editForm.staffMembers,
                                  function (item) {
                                    return _c(
                                      "div",
                                      {
                                        key: item.id,
                                        staticClass: "showMediaImg-left",
                                      },
                                      [
                                        item.isShowIframe
                                          ? _c("ImageIframe", {
                                              attrs: {
                                                url: item.headImage,
                                                option: "headImage",
                                              },
                                            })
                                          : _vm._e(),
                                        !item.headImage
                                          ? _c("span", [_vm._v("暂无图片")])
                                          : _vm._e(),
                                        _c("div", { attrs: { id: item.id } }),
                                        _c("p", [
                                          _vm._v("演员：" + _vm._s(item.name)),
                                        ]),
                                        _c(
                                          "p",
                                          {
                                            staticStyle: {
                                              "margin-top": "-1.25rem",
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "职务：" + _vm._s(item.position)
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "el-upload",
                                          {
                                            directives: [
                                              {
                                                name: "show",
                                                rawName: "v-show",
                                                value: !_vm.disabled,
                                                expression: "!disabled",
                                              },
                                            ],
                                            staticClass: "upload-demo",
                                            attrs: {
                                              "before-upload": _vm.checkUpload,
                                              "http-request": _vm.upload,
                                              listType: "picture-img",
                                              data: `${item.id}`,
                                              action: "headImage",
                                              "on-preview": _vm.handlePreview,
                                              "on-remove": _vm.handleRemove,
                                              "before-remove": _vm.beforeRemove,
                                              "on-exceed": _vm.handleExceed,
                                              "show-file-list": false,
                                            },
                                          },
                                          [
                                            _c(
                                              "el-button",
                                              {
                                                attrs: {
                                                  size: "small",
                                                  type: "primary",
                                                },
                                              },
                                              [_vm._v("重新上传")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  }
                                ),
                                0
                              )
                            : _c("div", [_vm._v("暂无数据")]),
                        ]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        width: "100%",
                        "max-height": "31.25rem",
                        overflow: "auto",
                        "margin-top": "3.125rem",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            prop: "mediaAsset.sourceType",
                            label: "剧集列表:",
                            "label-width": "20%",
                          },
                        },
                        [
                          _c(
                            "el-table",
                            {
                              staticStyle: { width: "100%" },
                              attrs: {
                                data: _vm.editForm.episodes,
                                border: "",
                              },
                            },
                            [
                              _c("el-table-column", {
                                attrs: { prop: "episodeName", label: "集名" },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "duration", label: "时长" },
                              }),
                              _c("el-table-column", {
                                attrs: { prop: "url", label: "页面访问地址" },
                              }),
                              _c("el-table-column", {
                                attrs: {
                                  prop: "urlScheme",
                                  label: "app跳转地址",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: !_vm.disabled,
                      expression: "!disabled",
                    },
                  ],
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c("el-button", { on: { click: _vm.dialogCancel } }, [
                    _vm._v("取 消"),
                  ]),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: { click: _vm.editDialogConfirm },
                    },
                    [_vm._v("确 定")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "关联媒资",
            visible: _vm.correlateDialog,
            width: "80%",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.correlateDialog = $event
            },
            closed: _vm.correlateDialogCancel,
            open: _vm.openEvent,
          },
        },
        [
          _c(
            "el-table",
            {
              ref: "mediaTable",
              staticStyle: { width: "100%" },
              attrs: { data: _vm.correlateData, border: "" },
              on: {
                "select-all": _vm.handleSelectionChange,
                select: _vm.handleSelectionChange,
              },
            },
            [
              _c("el-table-column", {
                attrs: { type: "selection", width: "55" },
              }),
              _c("el-table-column", {
                attrs: { prop: "name", label: "媒资名称", width: "180" },
              }),
              _c("el-table-column", {
                attrs: { prop: "sourceType", label: "来源平台", width: "100" },
              }),
              _c("el-table-column", {
                attrs: { prop: "tagName", label: "标签", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          _vm._l(scope.row.tagName.split(","), function (item) {
                            return _c(
                              "el-tag",
                              {
                                key: item.id,
                                staticStyle: {
                                  "margin-right": "10px",
                                  "margin-bottom": "5px",
                                },
                              },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(item) +
                                    "\n            "
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                staticClass: "correlate-description",
                attrs: {
                  "min-width": "80",
                  "show-overflow-tooltip": true,
                  prop: "description",
                  label: "描述",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "primary", label: "主媒资", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          on: {
                            change: function ($event) {
                              return _vm.handlePrimary(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.primary,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "primary", $$v)
                            },
                            expression: "scope.row.primary",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.correlateDialogCancel } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.correlateDialogConfirm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增媒资",
            visible: _vm.addDialog,
            width: "40%",
            "modal-append-to-body": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialog = $event
            },
            closed: _vm.addDialogCancel,
          },
        },
        [
          _c(
            "div",
            { staticClass: "add-container" },
            [
              _c(
                "el-form",
                {
                  ref: "addForm",
                  attrs: { model: _vm.addForm, rules: _vm.addRules },
                },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "输入url链接:",
                        "label-width": "20%",
                        prop: "url",
                      },
                    },
                    [
                      _c("el-input", {
                        staticStyle: { width: "90%" },
                        attrs: { clearable: "", placeholder: "请输入url链接" },
                        model: {
                          value: _vm.addForm.url,
                          callback: function ($$v) {
                            _vm.$set(_vm.addForm, "url", $$v)
                          },
                          expression: "addForm.url",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.addDialogCancel } }, [
                _vm._v("取 消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.addDialogConfirm },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ]
      ),
      _c("br"),
      _c(
        "div",
        { staticClass: "pagination", staticStyle: { "text-align": "right" } },
        [
          _c("ElementPagination", {
            attrs: {
              "current-page": _vm.searchForm.current,
              "page-size": _vm.searchForm.size,
              total: _vm.searchForm.total,
              "page-sizes": [10, 20, 30, 40, 50],
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _c("br"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }